module.exports = __webpack_public_path__ + "img/not-authorized-dark.de820d25.svg";